const sampleClientLookups = {
  agencyapprovals: [
    {
      key: "Fannie Approve",
      value: 2
    },
    {
      key: "Fannie EA Level I",
      value: 3
    },
    {
      key: "Fannie EA Level II",
      value: 4
    },
    {
      key: "Fannie EA Level III",
      value: 5
    },
    {
      key: "Freddie Accept",
      value: 7
    },
    {
      key: "Freddie A- Level 1",
      value: 8
    },
    {
      key: "Freddie A- Level 2",
      value: 9
    },
    {
      key: "Freddie A- Level 3",
      value: 10
    },
    {
      key: "Freddie A- Level 4",
      value: 11
    },
    {
      key: "Freddie A- Level 5",
      value: 12
    }
  ],
  bankruptcy: [
    {
      key: "Never or none in the last 7 years",
      value: 0,
      displayOrder: 0,
      abbreviation: null
    },
    {
      key: "Yes within last 60 to 84 months",
      value: 60,
      displayOrder: 0,
      abbreviation: null
    },
    {
      key: "Yes within last 48 to 60 months",
      value: 48,
      displayOrder: 0,
      abbreviation: null
    },
    {
      key: "Yes within last 36 to 48 months",
      value: 36,
      displayOrder: 0,
      abbreviation: null
    },
    {
      key: "Yes within last 24 to 36 months",
      value: 24,
      displayOrder: 0,
      abbreviation: null
    },
    {
      key: "Yes within last 18 to 24 months",
      value: 18,
      displayOrder: 0,
      abbreviation: null
    },
    {
      key: "Yes within last 12 to 18 months",
      value: 12,
      displayOrder: 0,
      abbreviation: null
    },
    {
      key: "Currently in Bankruptcy",
      value: 0,
      displayOrder: 0,
      abbreviation: null
    },
    {
      key: "Yes within last 6 to 12 months",
      value: 6,
      displayOrder: 0,
      abbreviation: null
    },
    {
      key: "Yes within last 0 to 6 months",
      value: 1,
      displayOrder: 0,
      abbreviation: null
    }
  ],
  bankruptcyType: [
    {
      bankruptcyTypeId: 1,
      descriptionText: "Chapter 7",
      displayOrder: 1
    },
    {
      bankruptcyTypeId: 2,
      descriptionText: "Chapter 11",
      displayOrder: 2
    },
    {
      bankruptcyTypeId: 3,
      descriptionText: "Chapter 13",
      displayOrder: 3
    }
  ],
  buydownContributorType: [
    {
      buydownContributorTypeId: 0,
      descriptionText: "None",
      displayOrder: 0
    },
    {
      buydownContributorTypeId: 1,
      descriptionText: "Lender",
      displayOrder: 1
    },
    {
      buydownContributorTypeId: 2,
      descriptionText: "Seller",
      displayOrder: 2
    },
    {
      buydownContributorTypeId: 3,
      descriptionText: "Builder",
      displayOrder: 3
    },
    {
      buydownContributorTypeId: 4,
      descriptionText: "Borrower",
      displayOrder: 4
    },
    {
      buydownContributorTypeId: 5,
      descriptionText: "Unassigned",
      displayOrder: 5
    },
    {
      buydownContributorTypeId: 6,
      descriptionText: "Parent",
      displayOrder: 6
    },
    {
      buydownContributorTypeId: 7,
      descriptionText: "Non-Parent Relative",
      displayOrder: 7
    },
    {
      buydownContributorTypeId: 8,
      descriptionText: "Unrelated Friend",
      displayOrder: 8
    },
    {
      buydownContributorTypeId: 9,
      descriptionText: "Employer",
      displayOrder: 9
    }
  ],
  buydownType: [
    {
      buydownTypeId: 0,
      descriptionText: "None",
      displayOrder: 0
    },
    {
      buydownTypeId: 1,
      descriptionText: "3-2-1",
      displayOrder: 1
    },
    {
      buydownTypeId: 2,
      descriptionText: "2-1",
      displayOrder: 2
    },
    {
      buydownTypeId: 3,
      descriptionText: "1-0",
      displayOrder: 6
    },
    {
      buydownTypeId: 4,
      descriptionText: "1.5-0.75",
      displayOrder: 3
    },
    {
      buydownTypeId: 5,
      descriptionText: "1-0.5",
      displayOrder: 5
    },
    {
      buydownTypeId: 6,
      descriptionText: "1-1",
      displayOrder: 4
    }
  ],
  commitmentTypes: [
    {
      commitmentTypeID: 2,
      description: "Best Efforts"
    },
    {
      commitmentTypeID: 1,
      description: "Mandatory"
    }
  ],
  clientSettings: [
    {
      options: {
        skipIncome: true,
        skipAssets: true,
        allowLock: true,
        roundCorr: true,
        roundBroker: true,
        noClosingCost: true,
        flagged: true,
        isMIQuotesEnabled: true,
        icePpeFloat: true,
        isBuySideHistorical: false,
        hideLockRequest: false,
        dataRetentionDays: 450
      },
      encompassSettings: {
        changeEffectiveDateOnReLock: true,
        changeProgramOnReLock: true,
        changeAdditionalLoanProg: true
      },
      productTypes: null
    }
  ],
  customFields: [
    {
      newFieldId: "LR.CX.LEAD.SOURCE",
      originalFieldId: "CX.LEAD.SOURCE",
      description: "Lead Source",
      type: "DROPDOWNLIST",
      editable: true,
      hidden: false,
      masterList: ["Self", "Internet", "Purchased", "Lending Tree"]
    },
    {
      newFieldId: "LR.CX.VIP",
      originalFieldId: "CX.VIP",
      description: "V.I.P. Customer",
      type: "YN",
      editable: false,
      hidden: true,
      masterList: ["Y", "N"]
    },
    {
      newFieldId: "LR.2626",
      originalFieldId: "2626",
      description: "Loan Info Channel",
      type: "DROPDOWN",
      editable: true,
      hidden: false,
      masterList: [
        "Banked - Retail",
        "Banked - Wholesale",
        "Brokered",
        "Correspondent"
      ]
    },
    {
      newFieldId: "LR.CX.5",
      originalFieldId: "CX.5",
      description: "Boolean",
      type: "YN",
      editable: true,
      hidden: false,
      masterList: ["Y", "N"]
    },
    {
      newFieldId: "LR.CX.26",
      originalFieldId: "CX.26",
      description: "Dropdown",
      type: "DROPDOWNLIST",
      editable: true,
      hidden: false,
      masterList: ["A", "B", "C"]
    },
    {
      newFieldId: "LR.CX.27",
      originalFieldId: "CX.27",
      description: "Dropdownlist",
      type: "DROPDOWN",
      editable: true,
      hidden: false,
      masterList: ["1", "2", "3", "4"]
    },
    {
      newFieldId: "LR.4181",
      originalFieldId: "4181",
      description: "Is Employee Loan?",
      type: "YN",
      editable: true,
      hidden: false,
      masterList: ["Y", "N"]
    },
    {
      newFieldId: "LR.CX.6",
      originalFieldId: "CX.6",
      description: "checkbox",
      type: "X",
      editable: true,
      hidden: false,
      masterList: ["X"]
    },
    {
      newFieldId: "LR.1612",
      originalFieldId: "1612",
      description: "Trans Details Interviewer Name",
      type: "STRING",
      editable: false,
      hidden: true,
      masterList: []
    },
    {
      newFieldId: "LR.CX.ANOTHER.INTEGER",
      originalFieldId: "CX.ANOTHER.INTEGER",
      description: "Another Integer",
      type: "INTEGER",
      editable: true,
      hidden: false,
      masterList: []
    },
    {
      newFieldId: "LR.364",
      originalFieldId: "364",
      description: "Trans Details Loan #",
      type: "STRING",
      editable: false,
      hidden: true,
      masterList: []
    },
    {
      newFieldId: "LR.CX.999",
      originalFieldId: "CX.999",
      description: "text",
      type: "STRING",
      editable: true,
      hidden: false,
      masterList: []
    },
    {
      newFieldId: "LR.CX.12",
      originalFieldId: "CX.12",
      description: "Integer",
      type: "INTEGER",
      editable: true,
      hidden: false,
      masterList: []
    },
    {
      newFieldId: "LR.CX.13",
      originalFieldId: "CX.13",
      description: "Float_1",
      type: "DECIMAL_1",
      editable: true,
      hidden: false,
      masterList: []
    },
    {
      newFieldId: "LR.CX.14",
      originalFieldId: "CX.14",
      description: "Float_2",
      type: "DECIMAL_2",
      editable: true,
      hidden: false,
      masterList: []
    },
    {
      newFieldId: "LR.CX.15",
      originalFieldId: "CX.15",
      description: "Float_3",
      type: "DECIMAL_3",
      editable: true,
      hidden: false,
      masterList: []
    },
    {
      newFieldId: "LR.CX.16",
      originalFieldId: "CX.16",
      description: "Float_4",
      type: "DECIMAL_4",
      editable: true,
      hidden: false,
      masterList: []
    },
    {
      newFieldId: "LR.CX.17",
      originalFieldId: "CX.17",
      description: "Float_5",
      type: "DECIMAL_5",
      editable: true,
      hidden: false,
      masterList: []
    },
    {
      newFieldId: "LR.CX.18",
      originalFieldId: "CX.18",
      description: "Float_6",
      type: "DECIMAL_6",
      editable: true,
      hidden: false,
      masterList: []
    },
    {
      newFieldId: "LR.CX.19",
      originalFieldId: "CX.19",
      description: "float_7",
      type: "DECIMAL_7",
      editable: true,
      hidden: false,
      masterList: []
    },
    {
      newFieldId: "LR.CX.20",
      originalFieldId: "CX.20",
      description: "Float_10",
      type: "DECIMAL_10",
      editable: true,
      hidden: false,
      masterList: []
    },
    {
      newFieldId: "LR.CX.21",
      originalFieldId: "CX.21",
      description: "FLoat",
      type: "DECIMAL",
      editable: true,
      hidden: false,
      masterList: []
    },
    {
      newFieldId: "LR.1240",
      originalFieldId: "1240",
      description: "Borr Email",
      type: "STRING",
      editable: false,
      hidden: true,
      masterList: []
    }
  ],
  documentationTypes: [
    {
      documentationId: 1,
      documentation: "Full Doc",
      income: 100,
      incomeLevel: "Full",
      assets: 100,
      assetsLevel: "Full",
      employment: 100,
      employmentLevel: "Full",
      displayOrder: 1
    },
    {
      documentationId: 9,
      documentation: "Limited Doc",
      income: 70,
      incomeLevel: "Limited",
      assets: 100,
      assetsLevel: "Full",
      employment: 100,
      employmentLevel: "Full",
      displayOrder: 2
    },
    {
      documentationId: 10,
      documentation: "Lite Doc",
      income: 60,
      incomeLevel: "Lite",
      assets: 100,
      assetsLevel: "Full",
      employment: 100,
      employmentLevel: "Full",
      displayOrder: 3
    },
    {
      documentationId: 2,
      documentation: "Stated",
      income: 50,
      incomeLevel: "Stated",
      assets: 100,
      assetsLevel: "Full",
      employment: 100,
      employmentLevel: "Full",
      displayOrder: 4
    },
    {
      documentationId: 3,
      documentation: "SISA",
      income: 50,
      incomeLevel: "Stated",
      assets: 50,
      assetsLevel: "Stated",
      employment: 100,
      employmentLevel: "Full",
      displayOrder: 6
    },
    {
      documentationId: 4,
      documentation: "No Ratio",
      income: 0,
      incomeLevel: "No",
      assets: 100,
      assetsLevel: "Full",
      employment: 100,
      employmentLevel: "Full",
      displayOrder: 7
    },
    {
      documentationId: 6,
      documentation: "NINA",
      income: 0,
      incomeLevel: "No",
      assets: 0,
      assetsLevel: "No",
      employment: 100,
      employmentLevel: "Full",
      displayOrder: 11
    },
    {
      documentationId: 7,
      documentation: "No Doc",
      income: 0,
      incomeLevel: "No",
      assets: 0,
      assetsLevel: "No",
      employment: 0,
      employmentLevel: "No",
      displayOrder: 13
    }
  ],
  foreclosure: [
    {
      key: "Never or none in the last 7 years",
      value: 0,
      displayOrder: 0,
      abbreviation: null
    },
    {
      key: "Yes within last 60 to 84 months",
      value: 60,
      displayOrder: 0,
      abbreviation: null
    },
    {
      key: "Yes within last 48 to 60 months",
      value: 48,
      displayOrder: 0,
      abbreviation: null
    },
    {
      key: "Yes within last 36 to 48 months",
      value: 36,
      displayOrder: 0,
      abbreviation: null
    },
    {
      key: "Yes within last 24 to 36 months",
      value: 24,
      displayOrder: 0,
      abbreviation: null
    },
    {
      key: "Yes within last 18 to 24 months",
      value: 18,
      displayOrder: 0,
      abbreviation: null
    },
    {
      key: "Yes within last 12 to 18 months",
      value: 12,
      displayOrder: 0,
      abbreviation: null
    },
    {
      key: "Currently in Default",
      value: 0,
      displayOrder: 0,
      abbreviation: null
    },
    {
      key: "Yes within last 6 to 12 months",
      value: 6,
      displayOrder: 0,
      abbreviation: null
    },
    {
      key: "Yes within last 0 to 6 months",
      value: 1,
      displayOrder: 0,
      abbreviation: null
    }
  ],
  citizenship: [
    {
      citizenshipId: 1,
      citizenship: "U.S. Citizen"
    },
    {
      citizenshipId: 2,
      citizenship: "Permanent Resident Alien"
    },
    {
      citizenshipId: 3,
      citizenship: "Non-Permanent Resident Alien"
    }
  ],
  propertyUse: [
    {
      key: "Pending Sale/Sold",
      value: 4,
      displayOrder: 0,
      abbreviation: null
    },
    {
      key: "Primary Residence",
      value: 1,
      displayOrder: 0,
      abbreviation: null
    },
    {
      key: "Secondary Residence",
      value: 2,
      displayOrder: 0,
      abbreviation: null
    },
    {
      key: "Investment/Rental",
      value: 3,
      displayOrder: 0,
      abbreviation: null
    },
    {
      key: "Other",
      value: 5,
      displayOrder: 0,
      abbreviation: null
    }
  ],
  propertyTypes: [
    {
      key: "1-Family",
      value: 1,
      abbreviation: "1F"
    },
    {
      key: "2-Family",
      value: 2,
      abbreviation: "2F"
    },
    {
      key: "3-Family",
      value: 3,
      abbreviation: "3F"
    },
    {
      key: "4-Family",
      value: 4,
      abbreviation: "4F"
    },
    {
      key: "Condo 1-4 Story",
      value: 5,
      abbreviation: "CL"
    },
    {
      key: "Condo 5-8 Story",
      value: 6,
      abbreviation: "CM"
    },
    {
      key: "Condo 9+ Story",
      value: 7,
      abbreviation: "CH"
    },
    {
      key: "Condo Detached",
      value: 12,
      abbreviation: "CD"
    },
    {
      key: "Townhouse",
      value: 8,
      abbreviation: "TH"
    },
    {
      key: "Coop",
      value: 9,
      abbreviation: "CP"
    },
    {
      key: "Double-wide Mobile",
      value: 10,
      abbreviation: "DM"
    },
    {
      key: "Manufactured",
      value: 11,
      abbreviation: "MN"
    },
    {
      key: "MH Advantage",
      value: 14,
      abbreviation: "MH"
    },
    {
      key: "PUD",
      value: 13,
      abbreviation: "PD"
    },
    {
      key: "PUD-Attached",
      value: 15,
      abbreviation: "PA"
    },
    {
      key: "MH CHOICEHome",
      value: 16,
      abbreviation: "MC"
    }
  ],
  deliveryTypes: [
    {
      key: "AOT",
      value: 4
    },
    {
      key: "Forwards",
      value: 6
    },
    {
      key: "Individual Best Efforts",
      value: 2
    },
    {
      key: "Individual Mandatory",
      value: 1
    },
    {
      key: "Live Trade",
      value: 5
    },
    {
      key: "Bulk",
      value: 3
    }
  ],
  encompassElements: [
    {
      key: "LienPos",
      value: "Lien position (1st, 2nd)"
    },
    {
      key: "Lender",
      value: "Lender (Borrower Summary)"
    },
    {
      key: "Notes",
      value: "Program notes"
    },
    {
      key: "PriceTableRawBuySide",
      value: "Price Table (raw) on Secondary Buy Requests"
    },
    {
      key: "LenderFeeWaiver",
      value: "Lender Fee Waiver"
    }
  ],
  investors: [
    {
      key: "AAA Test",
      value: 2
    },
    {
      key: "Abound Credit Union",
      value: 727
    },
    {
      key: "Absolute Home Mortgage CPM",
      value: 593
    },
    {
      key: "Advantis CU",
      value: 499
    },
    {
      key: "Affinity Plus Federal Credit Union",
      value: 440
    },
    {
      key: "AgFirst Farm Credit Bank",
      value: 671
    },
    {
      key: "AHL Funding CPM",
      value: 601
    },
    {
      key: "Altra Federal Credit Union CPM",
      value: 579
    },
    {
      key: "Amalgamated Bank",
      value: 495
    },
    {
      key: "America First CU",
      value: 318
    },
    {
      key: "America First CU CPM",
      value: 454
    },
    {
      key: "American Bancshares",
      value: 238
    },
    {
      key: "American Bank of Commerce",
      value: 676
    },
    {
      key: "American Eagle Financial Credit Union",
      value: 738
    },
    {
      key: "American Financial Resources",
      value: 69
    },
    {
      key: "American Financial Resources Delegated",
      value: 219
    },
    {
      key: "American Financial Resources Rate Table",
      value: 420
    },
    {
      key: "American Financial Resources Retail",
      value: 172
    },
    {
      key: "American Financial Resources Wholesale",
      value: 156
    },
    {
      key: "AmeriHome Direct Trade",
      value: 400
    },
    {
      key: "Amerihome Retail",
      value: 375
    },
    {
      key: "Amerisave Institutional Lending",
      value: 118
    },
    {
      key: "Angel Oak MS Broker",
      value: 684
    },
    {
      key: "Angel Oak MS Corr Del",
      value: 685
    },
    {
      key: "Angel Oak MS Corr NonDel",
      value: 686
    },
    {
      key: "Arc Home Delegated",
      value: 715
    },
    {
      key: "Arc Home Non-Delegated",
      value: 716
    },
    {
      key: "Arc Home Wholesale",
      value: 717
    },
    {
      key: "Associated Bank",
      value: 127
    },
    {
      key: "Auto Club Trust",
      value: 606
    },
    {
      key: "Banco Popular",
      value: 392
    },
    {
      key: "Banco Popular VI",
      value: 481
    },
    {
      key: "Bangor Savings Bank",
      value: 171
    },
    {
      key: "BANK",
      value: 561
    },
    {
      key: "BANK CPM",
      value: 544
    },
    {
      key: "BANK Fairfax",
      value: 563
    },
    {
      key: "BANK Firstrust",
      value: 564
    },
    {
      key: "BANK Legacy",
      value: 562
    },
    {
      key: "Bank of Hawaii Guam",
      value: 291
    },
    {
      key: "Bank of Hawaii Retail",
      value: 288
    },
    {
      key: "Bank of Hawaii Wholesale",
      value: 290
    },
    {
      key: "Bank of North Dakota",
      value: 615
    },
    {
      key: "Bank of North Dakota Retail",
      value: 619
    },
    {
      key: "Bank of Sun Prairie",
      value: 648
    },
    {
      key: "Bank of Tennessee",
      value: 377
    },
    {
      key: "Bankers Bank ",
      value: 353
    },
    {
      key: "Banner Bank",
      value: 206
    },
    {
      key: "Banner Corporation CPM",
      value: 565
    },
    {
      key: "Bayview Loan Servicing",
      value: 274
    },
    {
      key: "Bayview Loan Servicing Non-Del",
      value: 702
    },
    {
      key: "Berkshire Bank",
      value: 241
    },
    {
      key: "BNY Mellon",
      value: 363
    },
    {
      key: "BNY Mellon Retail",
      value: 429
    },
    {
      key: "Bradesco BAC Florida Bank",
      value: 299
    },
    {
      key: "Caliber Home Loans",
      value: 191
    },
    {
      key: "California State Housing",
      value: 373
    },
    {
      key: "Cambridge Trust Company",
      value: 382
    },
    {
      key: "Cambridge Trust Company CPM",
      value: 475
    },
    {
      key: "Camden National Bank",
      value: 227
    },
    {
      key: "Canvas Credit Union",
      value: 697
    },
    {
      key: "Canvas Credit Union CPM",
      value: 698
    },
    {
      key: "Capital City Home Loans",
      value: 343
    },
    {
      key: "Capital CU CPM",
      value: 500
    },
    {
      key: "Capitol Federal",
      value: 361
    },
    {
      key: "Capitol Federal Retail",
      value: 381
    },
    {
      key: "Capitol Federal TPO",
      value: 388
    },
    {
      key: "Carrington Mtg Services Corr",
      value: 540
    },
    {
      key: "Carrington Mtg Services Delegated",
      value: 668
    },
    {
      key: "Celebrity Home Loans",
      value: 509
    },
    {
      key: "Central Bancompany",
      value: 360
    },
    {
      key: "Central Bancompany PF",
      value: 372
    },
    {
      key: "Champions Mortgage CPM",
      value: 632
    },
    {
      key: "Charter Oak FCU",
      value: 734
    },
    {
      key: "Chelsea Groton Bank",
      value: 405
    },
    {
      key: "Chelsea Groton Bank CPM",
      value: 494
    },
    {
      key: "China Trust Bank",
      value: 130
    },
    {
      key: "Cincinnati Federal CPM ",
      value: 599
    },
    {
      key: "CIS Financial Services Correspondent",
      value: 322
    },
    {
      key: "CIS Financial Services Retail",
      value: 323
    },
    {
      key: "CIS Financial Services Wholesale",
      value: 324
    },
    {
      key: "Citadel Federal Credit Union Correspondent",
      value: 444
    },
    {
      key: "Citadel Federal Credit Union Retail",
      value: 441
    },
    {
      key: "Citimortgage",
      value: 22
    },
    {
      key: "Citizens Bank N.A. Broker",
      value: 307
    },
    {
      key: "Citizens Bank N.A. Corr",
      value: 306
    },
    {
      key: "Citizens Bank N.A. Mini Corr",
      value: 308
    },
    {
      key: "Citizens Community Federal",
      value: 714
    },
    {
      key: "Cliffco Mortgage Bankers CPM",
      value: 550
    },
    {
      key: "Coastway Community Bank",
      value: 269
    },
    {
      key: "Colonial Savings CPM",
      value: 665
    },
    {
      key: "Columbia Bank",
      value: 374
    },
    {
      key: "Columbia Bank TPO ",
      value: 402
    },
    {
      key: "Columbus Capital Lending CPM",
      value: 532
    },
    {
      key: "Community 1st Credit Union",
      value: 345
    },
    {
      key: "Community Bank NA",
      value: 584
    },
    {
      key: "Community Credit Union of Florida",
      value: 417
    },
    {
      key: "Community Financial CU",
      value: 461
    },
    {
      key: "Community Mortgage Funding LLC CPM",
      value: 577
    },
    {
      key: "Connecticut State Housing",
      value: 279
    },
    {
      key: "Cornerstone",
      value: 189
    },
    {
      key: "Credit Human FCU",
      value: 662
    },
    {
      key: "Credit Union of Southern California CPM",
      value: 547
    },
    {
      key: "Deephaven Mortgage",
      value: 384
    },
    {
      key: "Deere Employees Credit Union ",
      value: 522
    },
    {
      key: "Deere Employees Credit Union CPM",
      value: 526
    },
    {
      key: "Delaware County Bank",
      value: 350
    },
    {
      key: "Delaware State Housing",
      value: 280
    },
    {
      key: "Delta Community Credit Union",
      value: 462
    },
    {
      key: "Developers Mortgage Company CPM",
      value: 620
    },
    {
      key: "Dickinson Financial Corporation",
      value: 573
    },
    {
      key: "Dime Community Bank Retail",
      value: 465
    },
    {
      key: "Dime Community Bank Wholesale",
      value: 467
    },
    {
      key: "East West Bank",
      value: 725
    },
    {
      key: "East West Mortgage LLC CPM",
      value: 527
    },
    {
      key: "Eastern Savings Bank",
      value: 281
    },
    {
      key: "Eastman Credit Union",
      value: 226
    },
    {
      key: "Eastman Credit Union CPM",
      value: 511
    },
    {
      key: "Ent Credit Union",
      value: 401
    },
    {
      key: "Ent Credit Union CPM ",
      value: 568
    },
    {
      key: "ESL FCU CPM",
      value: 724
    },
    {
      key: "Essex Mortgage BE",
      value: 692
    },
    {
      key: "Essex Mortgage MAND",
      value: 693
    },
    {
      key: "Evans Bank CPM ",
      value: 625
    },
    {
      key: "EvergreenCU CPM",
      value: 524
    },
    {
      key: "Exponential Mortgage",
      value: 711
    },
    {
      key: "F&M Trust",
      value: 295
    },
    {
      key: "Fairfield County Bank",
      value: 252
    },
    {
      key: "Fairwinds Credit Union",
      value: 407
    },
    {
      key: "Farmers & Merchants State Bank",
      value: 669
    },
    {
      key: "FBC Mortgage",
      value: 263
    },
    {
      key: "Federal Savings Bank CPM",
      value: 607
    },
    {
      key: "FFIEC",
      value: 200
    },
    {
      key: "FHLB Cincinnati",
      value: 334
    },
    {
      key: "FHLB Released",
      value: 205
    },
    {
      key: "FHLB Retained",
      value: 201
    },
    {
      key: "FHLMC BE",
      value: 113
    },
    {
      key: "FHLMC MAND",
      value: 114
    },
    {
      key: "Fidelity Bank",
      value: 314
    },
    {
      key: "Fifth Third Mortgage",
      value: 103
    },
    {
      key: "First Ameircan Bank CPM",
      value: 726
    },
    {
      key: "First Bank and Trust 927145 CPM",
      value: 501
    },
    {
      key: "First Bank CPM",
      value: 652
    },
    {
      key: "First Bank Puerto Rico",
      value: 380
    },
    {
      key: "First Citizens Bank",
      value: 178
    },
    {
      key: "First Columbia Bank And Trust CPM",
      value: 553
    },
    {
      key: "First Community Mortgage",
      value: 313
    },
    {
      key: "First Community Mortgage Wholesale",
      value: 463
    },
    {
      key: "First County Bank CPM",
      value: 480
    },
    {
      key: "First Entertainment CU",
      value: 572
    },
    {
      key: "First Equity Mortgage Bankers",
      value: 720
    },
    {
      key: "First Farmers and Merchants Bank",
      value: 695
    },
    {
      key: "First Federal",
      value: 330
    },
    {
      key: "First Federal Bank",
      value: 215
    },
    {
      key: "First Federal Bank of Louisiana",
      value: 398
    },
    {
      key: "First Federal Bank Wholesale",
      value: 661
    },
    {
      key: "First Federal Lakewood",
      value: 616
    },
    {
      key: "First Financial Federal Credit Union of Maryland",
      value: 683
    },
    {
      key: "First Guaranty Delegated",
      value: 351
    },
    {
      key: "First Hawaiian Bank Retail",
      value: 293
    },
    {
      key: "First Hawaiian Bank Wholesale",
      value: 294
    },
    {
      key: "First Mutual Holding Co",
      value: 296
    },
    {
      key: "First Mutual Holding Co CPM",
      value: 474
    },
    {
      key: "First Mutual Holding Co TPO",
      value: 457
    },
    {
      key: "First National Bank of PA",
      value: 664
    },
    {
      key: "First Piedmont Federal Savings and Loan CPM",
      value: 545
    },
    {
      key: "First Savings Bank Correspondent",
      value: 604
    },
    {
      key: "First Savings Bank Wholesale",
      value: 603
    },
    {
      key: "First Technology Federal Credit Union CPM",
      value: 646
    },
    {
      key: "FirstLight Federal Credit Union",
      value: 690
    },
    {
      key: "Firstrust Bank Correspondent",
      value: 530
    },
    {
      key: "Firstrust Bank Retail",
      value: 395
    },
    {
      key: "Firstrust Bank Wholesale",
      value: 396
    },
    {
      key: "Flagstar",
      value: 6
    },
    {
      key: "Flagstar Lending Space",
      value: 123
    },
    {
      key: "Flat Branch Home Loans",
      value: 336
    },
    {
      key: "Florida Credit Union",
      value: 583
    },
    {
      key: "FNMA BE",
      value: 110
    },
    {
      key: "FNMA MAND",
      value: 111
    },
    {
      key: "Franklin First Financial",
      value: 225
    },
    {
      key: "Freedom Corr",
      value: 193
    },
    {
      key: "Freedom GRH",
      value: 337
    },
    {
      key: "Freedom Renovation",
      value: 128
    },
    {
      key: "Freedom Retail",
      value: 331
    },
    {
      key: "Freedom Wholesale",
      value: 78
    },
    {
      key: "Gateway First Bank",
      value: 153
    },
    {
      key: "Genesee Regional Bank CPM",
      value: 657
    },
    {
      key: "Georgia United Credit Union",
      value: 349
    },
    {
      key: "GMFS Mortgage Delegated",
      value: 634
    },
    {
      key: "GMFS Mortgage Wholesale",
      value: 635
    },
    {
      key: "Gold Star Financial",
      value: 246
    },
    {
      key: "Googain",
      value: 478
    },
    {
      key: "Graystone CPM",
      value: 609
    },
    {
      key: "Great Lakes CU CPM",
      value: 628
    },
    {
      key: "Guaranty Bank & Trust CPM",
      value: 666
    },
    {
      key: "Guild Mortgage Co",
      value: 146
    },
    {
      key: "GVC Mortgage",
      value: 262
    },
    {
      key: "GVCMortgage CPM",
      value: 546
    },
    {
      key: "Hartford Funding",
      value: 332
    },
    {
      key: "Haven Savings Bank",
      value: 397
    },
    {
      key: "Heartland Bank CPM",
      value: 629
    },
    {
      key: "Helm Bank USA",
      value: 674
    },
    {
      key: "Heritage Fed CU",
      value: 651
    },
    {
      key: "Holy Rosary Credit Union",
      value: 442
    },
    {
      key: "Home Federal Bank of Tennessee",
      value: 729
    },
    {
      key: "Home Point Financial Corporation",
      value: 134
    },
    {
      key: "Home Point Financial Wholesale",
      value: 633
    },
    {
      key: "Homestar Financial Corp",
      value: 621
    },
    {
      key: "HomeTrust Bank",
      value: 354
    },
    {
      key: "Horizon Bank NA CPM",
      value: 636
    },
    {
      key: "Huntington National Bank",
      value: 216
    },
    {
      key: "ICE Mort Tech CPM",
      value: 431
    },
    {
      key: "ICE Mort Tech FHA",
      value: 421
    },
    {
      key: "ICE Mort Tech FHLMC",
      value: 427
    },
    {
      key: "ICE Mort Tech FNMA",
      value: 426
    },
    {
      key: "ICE Mort Tech USDA",
      value: 424
    },
    {
      key: "ICE Mort Tech VA",
      value: 423
    },
    {
      key: "Illinois Housing Development Authority CPM",
      value: 578
    },
    {
      key: "IllinoisHousingDA QA Environ CPM",
      value: 639
    },
    {
      key: "Independent Bank",
      value: 309
    },
    {
      key: "InRoads FCU",
      value: 333
    },
    {
      key: "Investar Bank",
      value: 680
    },
    {
      key: "Iowa Bankers Mortgage Corp Alliance",
      value: 706
    },
    {
      key: "Iowa Bankers Mortgage Corp Core",
      value: 705
    },
    {
      key: "Iowa Bankers Mortgage Corp Delegated",
      value: 707
    },
    {
      key: "Iowa Bankers Mortgage Corp Government",
      value: 708
    },
    {
      key: "Iowa Bankers Mtg Co RuraLiving",
      value: 364
    },
    {
      key: "Iowa Bankers Mtg Company Correspondent  ",
      value: 356
    },
    {
      key: "Iowa Bankers Mtg Company IFA",
      value: 359
    },
    {
      key: "Iowa Bankers Mtg Company Retail ",
      value: 358
    },
    {
      key: "Iowa Bankers Mtg Company Wholesale  ",
      value: 357
    },
    {
      key: "Kennebunk Savings Bank",
      value: 329
    },
    {
      key: "Lake Ridge Bancorp",
      value: 737
    },
    {
      key: "Lakeland Bank CPM",
      value: 505
    },
    {
      key: "Lakeview Loan Servicing",
      value: 687
    },
    {
      key: "Lakeview Loan Servicing Non-Del",
      value: 703
    },
    {
      key: "Level One CPM",
      value: 656
    },
    {
      key: "Liberty Bank",
      value: 594
    },
    {
      key: "Liberty Savings Bank",
      value: 404
    },
    {
      key: "Loan Depot",
      value: 483
    },
    {
      key: "LoanStream Mortgage Correspondent",
      value: 370
    },
    {
      key: "LoanStream Mortgage Emerging Banker",
      value: 718
    },
    {
      key: "LoanStream Mortgage Wholesale",
      value: 719
    },
    {
      key: "Long Beach City Employees FCU",
      value: 592
    },
    {
      key: "Luxury Mortgage Correspondent",
      value: 610
    },
    {
      key: "Luxury Mortgage Wholesale",
      value: 611
    },
    {
      key: "Lyons National Bank CPM",
      value: 658
    },
    {
      key: "M&T Bank",
      value: 61
    },
    {
      key: "M&T Wholesale",
      value: 243
    },
    {
      key: "Machias Savings Bank",
      value: 411
    },
    {
      key: "Maine State Housing",
      value: 176
    },
    {
      key: "Maryland State Housing",
      value: 282
    },
    {
      key: "Massachusetts State Housing",
      value: 311
    },
    {
      key: "MaxEx Clearing LLC",
      value: 566
    },
    {
      key: "Mechanics Bank",
      value: 477
    },
    {
      key: "Members Cooperative Credit Union",
      value: 699
    },
    {
      key: "Members Cooperative Credit Union CPM",
      value: 691
    },
    {
      key: "Members Mortgage Services CPM",
      value: 694
    },
    {
      key: "Mercantile Bank of Michigan",
      value: 525
    },
    {
      key: "Mercantile Bank of Michigan CPM",
      value: 512
    },
    {
      key: "Merchants Bank of IN",
      value: 447
    },
    {
      key: "Merchants Bank of Indiana Correspondent",
      value: 624
    },
    {
      key: "Meridian Bank CPM",
      value: 644
    },
    {
      key: "Money House Puerto Rico",
      value: 518
    },
    {
      key: "Money Source",
      value: 302
    },
    {
      key: "Money Source Retail",
      value: 445
    },
    {
      key: "Monona Bank",
      value: 521
    },
    {
      key: "Montgomery County State Housing",
      value: 277
    },
    {
      key: "Mortgage 1",
      value: 100
    },
    {
      key: "Mortgage 1 Specialty Products",
      value: 452
    },
    {
      key: "Mortgage Company CPM",
      value: 730
    },
    {
      key: "Mortgage Firm Inc CPM",
      value: 617
    },
    {
      key: "Mortgage House",
      value: 217
    },
    {
      key: "Mortgage Solutions Financial Correspondent",
      value: 712
    },
    {
      key: "Mortgage Solutions Financial Wholesale",
      value: 713
    },
    {
      key: "Mortgages Unlimited CPM ",
      value: 555
    },
    {
      key: "Mr Cooper",
      value: 101
    },
    {
      key: "Mr Cooper Non-Delegated",
      value: 660
    },
    {
      key: "Mr Cooper RETIRED",
      value: 223
    },
    {
      key: "Mutual Bank",
      value: 325
    },
    {
      key: "Navy Army CU",
      value: 600
    },
    {
      key: "NBTBank",
      value: 623
    },
    {
      key: "New Hampshire Mutual Bancorp CPM",
      value: 554
    },
    {
      key: "New Hampshire Mutual Bancorp MCSB MVSB",
      value: 581
    },
    {
      key: "New Hampshire Mutual Bancorp SBW",
      value: 582
    },
    {
      key: "New Hampshire State Housing",
      value: 574
    },
    {
      key: "New Jersey State Housing",
      value: 268
    },
    {
      key: "Newburyport Five Cents Savings Bank",
      value: 321
    },
    {
      key: "NewRez Corr",
      value: 168
    },
    {
      key: "NewRez Mini Corr",
      value: 298
    },
    {
      key: "NewRez Wholesale",
      value: 297
    },
    {
      key: "Newtown Savings Bank",
      value: 327
    },
    {
      key: "NexBank",
      value: 710
    },
    {
      key: "Nicolet National Bank",
      value: 473
    },
    {
      key: "NOLA Lending Group",
      value: 195
    },
    {
      key: "Northcountry Federal Credit Union CPM",
      value: 618
    },
    {
      key: "Northfield Savings Bank",
      value: 504
    },
    {
      key: "Northpointe Bank",
      value: 430
    },
    {
      key: "NOVA Home Loans",
      value: 371
    },
    {
      key: "Ocean First Bank",
      value: 283
    },
    {
      key: "OGI Mortgage Bankers",
      value: 362
    },
    {
      key: "Old National 11158009 CPM",
      value: 586
    },
    {
      key: "Old National Bank",
      value: 355
    },
    {
      key: "Olympia Federal Savings & Loan",
      value: 513
    },
    {
      key: "OnPoint CU",
      value: 237
    },
    {
      key: "OnQ Financial",
      value: 638
    },
    {
      key: "OnQ Financial Non Del",
      value: 641
    },
    {
      key: "Optima Bank & Trust",
      value: 506
    },
    {
      key: "Oriental Bank",
      value: 659
    },
    {
      key: "Origin Bank",
      value: 437
    },
    {
      key: "Origin Bank CPM",
      value: 542
    },
    {
      key: "Pacific Bay Lending Group",
      value: 328
    },
    {
      key: "Park National Bank",
      value: 379
    },
    {
      key: "PARTNER TSP Consulting CPM",
      value: 688
    },
    {
      key: "Partners Bank of New England",
      value: 613
    },
    {
      key: "Pennsylvania State Housing",
      value: 271
    },
    {
      key: "PennyMac",
      value: 109
    },
    {
      key: "PennyMac Non-Delegated",
      value: 376
    },
    {
      key: "PennyMac Wholesale",
      value: 614
    },
    {
      key: "Pentagon Federal Credit Union",
      value: 264
    },
    {
      key: "Pentagon Federal Credit Union Non-Del",
      value: 672
    },
    {
      key: "Peoples Bank",
      value: 240
    },
    {
      key: "Peoples Bank WA",
      value: 276
    },
    {
      key: "Peoples Bank WA CPM",
      value: 575
    },
    {
      key: "Peoples United Bank Correspondent",
      value: 588
    },
    {
      key: "Peoples United Bank Retail",
      value: 589
    },
    {
      key: "Peoples United Bank Wholesale",
      value: 587
    },
    {
      key: "Phelps County Bank CPM",
      value: 520
    },
    {
      key: "PHH Mortgage",
      value: 670
    },
    {
      key: "PHH Mortgage Non Del",
      value: 675
    },
    {
      key: "Pinnacle Bank",
      value: 409
    },
    {
      key: "Plains Commerce Bank Delegated",
      value: 677
    },
    {
      key: "Plains Commerce Bank NonDelegated",
      value: 678
    },
    {
      key: "Plains Commerce Bank Wholesale",
      value: 679
    },
    {
      key: "Planet Home Lending Correspondent",
      value: 186
    },
    {
      key: "Planet Home Lending New Business",
      value: 340
    },
    {
      key: "Planet Home Lending Non-Del",
      value: 653
    },
    {
      key: "Planet Home Lending Retail",
      value: 300
    },
    {
      key: "Planet Home Lending Retail Puerto Rico",
      value: 689
    },
    {
      key: "Planet Home Lending Wholesale",
      value: 339
    },
    {
      key: "Plaza Home Mortgage",
      value: 86
    },
    {
      key: "Plaza Wholesale",
      value: 182
    },
    {
      key: "Power Choice Mtg CPM",
      value: 557
    },
    {
      key: "Preferred Bank",
      value: 391
    },
    {
      key: "Premier Bank",
      value: 383
    },
    {
      key: "Princeton Mortgage Corp CPM",
      value: 627
    },
    {
      key: "PRMG Correspondent",
      value: 493
    },
    {
      key: "PRMG Correspondent Delegated",
      value: 605
    },
    {
      key: "PRMG Wholesale",
      value: 502
    },
    {
      key: "Provident Bank Mortgage Retail",
      value: 413
    },
    {
      key: "Provident Bank Mortgage Wholesale",
      value: 414
    },
    {
      key: "Provident Credit Union",
      value: 257
    },
    {
      key: "Province Mortgage Associates Inc CPM ",
      value: 667
    },
    {
      key: "QA Automation Bank",
      value: 344
    },
    {
      key: "Randolph Brooks Federal CU",
      value: 468
    },
    {
      key: "Rate Plus Inc ",
      value: 626
    },
    {
      key: "RBC Bank",
      value: 541
    },
    {
      key: "Redwood Trust",
      value: 185
    },
    {
      key: "Reliant Community Credit Union CPM",
      value: 723
    },
    {
      key: "RenasantCorr",
      value: 556
    },
    {
      key: "RenasantMiniCorr",
      value: 570
    },
    {
      key: "Residential Mortgage",
      value: 137
    },
    {
      key: "Retired Modules",
      value: 645
    },
    {
      key: "Revolution Mortgage CPM",
      value: 622
    },
    {
      key: "RhinebeckBank",
      value: 643
    },
    {
      key: "Rhode Island H&M Finance Corr CPM",
      value: 469
    },
    {
      key: "Rhode Island H&M Finance Retail CPM",
      value: 470
    },
    {
      key: "Rhode Island H&M Finance Whls CPM",
      value: 471
    },
    {
      key: "Rocket Pro TPO Non-Del Corr",
      value: 99
    },
    {
      key: "Rocket Pro TPO Wholesale",
      value: 701
    },
    {
      key: "Rockland FCU CPM",
      value: 663
    },
    {
      key: "RTN Federal Credit Union",
      value: 387
    },
    {
      key: "Ruoff Home Mortgage",
      value: 143
    },
    {
      key: "Rushmore Correspondent",
      value: 255
    },
    {
      key: "SAFE Credit Union",
      value: 260
    },
    {
      key: "SAFE CU TEST",
      value: 482
    },
    {
      key: "Salem Five",
      value: 192
    },
    {
      key: "San Francisco FCU CPM",
      value: 602
    },
    {
      key: "San Francisco Federal Credit Union",
      value: 403
    },
    {
      key: "Santa Clara County FCU",
      value: 548
    },
    {
      key: "SCCFCU",
      value: 682
    },
    {
      key: "Schools First Federal CU",
      value: 422
    },
    {
      key: "Scient Federal CU CPM",
      value: 739
    },
    {
      key: "Security Home Mortgage CPM",
      value: 576
    },
    {
      key: "SEFCU Mortgage Services",
      value: 138
    },
    {
      key: "Servion",
      value: 258
    },
    {
      key: "Servion Correspondent",
      value: 419
    },
    {
      key: "Servion Wholesale ",
      value: 709
    },
    {
      key: "ServisFirst Bank",
      value: 287
    },
    {
      key: "Shea Mortgage CPM",
      value: 531
    },
    {
      key: "Sierra Pacific Correspondent",
      value: 367
    },
    {
      key: "Sierra Pacific Wholesale",
      value: 368
    },
    {
      key: "Simsbury Bank",
      value: 98
    },
    {
      key: "SONYMA",
      value: 196
    },
    {
      key: "Sound Community Bank CPM",
      value: 551
    },
    {
      key: "South Carolina State Housing",
      value: 177
    },
    {
      key: "South State Bank",
      value: 188
    },
    {
      key: "SouthPoint Federal Credit Union CPM",
      value: 549
    },
    {
      key: "Southside Bank CPM",
      value: 517
    },
    {
      key: "SouthStateBank11144084 CPM",
      value: 453
    },
    {
      key: "Spire Credit Union CPM ",
      value: 558
    },
    {
      key: "Spokane Teachers CU CPM",
      value: 523
    },
    {
      key: "Sprout Mortgage",
      value: 412
    },
    {
      key: "Sprout Mortgage Wholesale",
      value: 596
    },
    {
      key: "SRPFederalCU",
      value: 390
    },
    {
      key: "Starboard Financial Management CPM",
      value: 630
    },
    {
      key: "State Bank of Cross Plains",
      value: 571
    },
    {
      key: "Stearns Wholesale",
      value: 220
    },
    {
      key: "Stockman Bank of Montana CPM",
      value: 595
    },
    {
      key: "Stockton Mortgage",
      value: 415
    },
    {
      key: "Stockton Mortgage Del Corr",
      value: 450
    },
    {
      key: "Stockton Mortgage NonDel Corr",
      value: 451
    },
    {
      key: "Stockton Mortgage Wholesale",
      value: 449
    },
    {
      key: "Strong Home Mortgage",
      value: 681
    },
    {
      key: "Teachers Credit Union CPM",
      value: 733
    },
    {
      key: "Texas Dow Employees Credit Union",
      value: 655
    },
    {
      key: "Texas Dow Employees Credit Union Corr",
      value: 696
    },
    {
      key: "Think Mutual Bank",
      value: 428
    },
    {
      key: "Tidemark Federal Credit Union",
      value: 516
    },
    {
      key: "Towne Mortgage",
      value: 472
    },
    {
      key: "Tropical Financial Credit Union",
      value: 503
    },
    {
      key: "Truist Bank",
      value: 55
    },
    {
      key: "Truist Bank CorrAdvantage",
      value: 637
    },
    {
      key: "TruStone Financial Credit Union CPM",
      value: 591
    },
    {
      key: "TwinStar Credit Union CPM",
      value: 650
    },
    {
      key: "Ulster Savings Bank",
      value: 190
    },
    {
      key: "Umpqua Bank",
      value: 94
    },
    {
      key: "Uncle Credit Union",
      value: 529
    },
    {
      key: "Union Home Mortgage",
      value: 732
    },
    {
      key: "United Bank",
      value: 317
    },
    {
      key: "United Bank CPM",
      value: 559
    },
    {
      key: "United Community Bank",
      value: 342
    },
    {
      key: "United Federal Credit Union",
      value: 245
    },
    {
      key: "United Northern",
      value: 232
    },
    {
      key: "United Wholesale Mortgage",
      value: 369
    },
    {
      key: "University Wisconsin Credit Union",
      value: 304
    },
    {
      key: "Univest Corp",
      value: 394
    },
    {
      key: "US Bank",
      value: 43
    },
    {
      key: "Vermont State Housing",
      value: 507
    },
    {
      key: "Verus Mortgage Capital",
      value: 393
    },
    {
      key: "Village Capital & Investment",
      value: 459
    },
    {
      key: "Virginia Credit Union",
      value: 408
    },
    {
      key: "Virginia State Housing",
      value: 275
    },
    {
      key: "VyStar Credit Union ",
      value: 439
    },
    {
      key: "Washington Federal Bank Retail",
      value: 597
    },
    {
      key: "Washington Federal Bank Whls",
      value: 598
    },
    {
      key: "Water & Power CCU",
      value: 214
    },
    {
      key: "Weichert Financial",
      value: 261
    },
    {
      key: "Weichert Financial CPM",
      value: 534
    },
    {
      key: "Wells Fargo",
      value: 19
    },
    {
      key: "Wells Fargo SRP",
      value: 135
    },
    {
      key: "WesBanco",
      value: 292
    },
    {
      key: "WesBanco Bank, Inc CPM",
      value: 528
    },
    {
      key: "West Gate Corr Del",
      value: 721
    },
    {
      key: "West Gate Corr Non-Del",
      value: 722
    },
    {
      key: "Westfield Bank CPM",
      value: 731
    },
    {
      key: "WeStreet Federal Credit Union",
      value: 673
    },
    {
      key: "Whatcom Educational Credit Union",
      value: 456
    },
    {
      key: "Wintrust Mortgage",
      value: 82
    },
    {
      key: "Zions Bancorp",
      value: 590
    }
  ],
  lienPos: [
    {
      key: "1st Mortgage",
      value: 1
    },
    {
      key: "2nd Mortgage",
      value: 2
    }
  ],
  lockdays: [
    {
      lockDays: 0,
      virtualLock: 0
    },
    {
      lockDays: 5,
      virtualLock: 5
    },
    {
      lockDays: 10,
      virtualLock: 88
    },
    {
      lockDays: 15,
      virtualLock: 16
    },
    {
      lockDays: 20,
      virtualLock: 20
    },
    {
      lockDays: 30,
      virtualLock: 31
    },
    {
      lockDays: 35,
      virtualLock: 35
    },
    {
      lockDays: 45,
      virtualLock: 46
    },
    {
      lockDays: 60,
      virtualLock: 61
    },
    {
      lockDays: 75,
      virtualLock: 76
    },
    {
      lockDays: 90,
      virtualLock: 91
    },
    {
      lockDays: 120,
      virtualLock: 120
    },
    {
      lockDays: 150,
      virtualLock: 150
    },
    {
      lockDays: 180,
      virtualLock: 180
    },
    {
      lockDays: 210,
      virtualLock: 210
    },
    {
      lockDays: 240,
      virtualLock: 240
    },
    {
      lockDays: 270,
      virtualLock: 270
    },
    {
      lockDays: 360,
      virtualLock: 360
    },
    {
      lockDays: 540,
      virtualLock: 0
    }
  ],
  loanTerms: [
    {
      value: 132,
      key: "NEW FIXED",
      term: 31,
      fixedTerm: 372,
      amortization: 31,
      arm: false,
      heloc: false
    },
    {
      value: 169,
      key: "test ap 68100",
      term: 30,
      fixedTerm: 360,
      amortization: 30,
      arm: false,
      heloc: false
    },
    {
      value: 1,
      key: "30 Year Fixed",
      term: 30,
      fixedTerm: 360,
      amortization: 30,
      arm: false,
      heloc: false
    },
    {
      value: 20,
      key: "25 Year Fixed",
      term: 25,
      fixedTerm: 300,
      amortization: 25,
      arm: false,
      heloc: false
    },
    {
      value: 2,
      key: "20 Year Fixed",
      term: 20,
      fixedTerm: 240,
      amortization: 20,
      arm: false,
      heloc: false
    },
    {
      value: 3,
      key: "15 Year Fixed",
      term: 15,
      fixedTerm: 180,
      amortization: 15,
      arm: false,
      heloc: false
    },
    {
      value: 150,
      key: "Term_17_ Fixed",
      term: 17,
      fixedTerm: 204,
      amortization: 17,
      arm: false,
      heloc: false
    },
    {
      value: 23,
      key: "12 Year Fixed",
      term: 12,
      fixedTerm: 144,
      amortization: 12,
      arm: false,
      heloc: false
    },
    {
      value: 156,
      key: "Term_20_Fxed",
      term: 20,
      fixedTerm: 240,
      amortization: 20,
      arm: false,
      heloc: false
    },
    {
      value: 4,
      key: "10 Year Fixed",
      term: 10,
      fixedTerm: 120,
      amortization: 10,
      arm: false,
      heloc: false
    },
    {
      value: 14,
      key: "40 Year Fixed",
      term: 40,
      fixedTerm: 480,
      amortization: 40,
      arm: false,
      heloc: false
    },
    {
      value: 24,
      key: "1 Year Fixed",
      term: 1,
      fixedTerm: 12,
      amortization: 1,
      arm: false,
      heloc: false
    },
    {
      value: 25,
      key: "2 Year Fixed",
      term: 2,
      fixedTerm: 24,
      amortization: 2,
      arm: false,
      heloc: false
    },
    {
      value: 26,
      key: "3 Year Fixed",
      term: 3,
      fixedTerm: 36,
      amortization: 3,
      arm: false,
      heloc: false
    },
    {
      value: 27,
      key: "4 Year Fixed",
      term: 4,
      fixedTerm: 48,
      amortization: 4,
      arm: false,
      heloc: false
    },
    {
      value: 19,
      key: "5 Year Fixed",
      term: 5,
      fixedTerm: 60,
      amortization: 5,
      arm: false,
      heloc: false
    },
    {
      value: 28,
      key: "6 Year Fixed",
      term: 6,
      fixedTerm: 72,
      amortization: 6,
      arm: false,
      heloc: false
    },
    {
      value: 29,
      key: "7 Year Fixed",
      term: 7,
      fixedTerm: 84,
      amortization: 7,
      arm: false,
      heloc: false
    },
    {
      value: 30,
      key: "8 Year Fixed",
      term: 8,
      fixedTerm: 96,
      amortization: 8,
      arm: false,
      heloc: false
    },
    {
      value: 134,
      key: "Term_30__Fixed",
      term: 30,
      fixedTerm: 360,
      amortization: 30,
      arm: false,
      heloc: false
    },
    {
      value: 32,
      key: "11 Year Fixed",
      term: 11,
      fixedTerm: 132,
      amortization: 11,
      arm: false,
      heloc: false
    },
    {
      value: 34,
      key: "14 Year Fixed",
      term: 14,
      fixedTerm: 168,
      amortization: 14,
      arm: false,
      heloc: false
    },
    {
      value: 36,
      key: "17 Year Fixed",
      term: 17,
      fixedTerm: 204,
      amortization: 17,
      arm: false,
      heloc: false
    },
    {
      value: 43,
      key: "26 Year Fixed",
      term: 26,
      fixedTerm: 312,
      amortization: 26,
      arm: false,
      heloc: false
    },
    {
      value: 46,
      key: "29 Year Fixed",
      term: 29,
      fixedTerm: 348,
      amortization: 29,
      arm: false,
      heloc: false
    },
    {
      value: 22,
      key: "15 Year ARM",
      term: 30,
      fixedTerm: 180,
      amortization: 30,
      arm: true,
      heloc: false
    },
    {
      value: 5,
      key: "10 Year ARM",
      term: 30,
      fixedTerm: 120,
      amortization: 30,
      arm: true,
      heloc: false
    },
    {
      value: 6,
      key: "7 Year ARM",
      term: 30,
      fixedTerm: 84,
      amortization: 30,
      arm: true,
      heloc: false
    },
    {
      value: 8,
      key: "3 Year ARM",
      term: 30,
      fixedTerm: 36,
      amortization: 30,
      arm: true,
      heloc: false
    },
    {
      value: 10,
      key: "1 Year ARM",
      term: 30,
      fixedTerm: 12,
      amortization: 30,
      arm: true,
      heloc: false
    },
    {
      value: 7,
      key: "5 Year ARM",
      term: 30,
      fixedTerm: 60,
      amortization: 30,
      arm: true,
      heloc: false
    },
    {
      value: 72,
      key: "1 Year ARM 180",
      term: 15,
      fixedTerm: 12,
      amortization: 15,
      arm: true,
      heloc: false
    },
    {
      value: 98,
      key: "2 Year ARM 180",
      term: 15,
      fixedTerm: 24,
      amortization: 15,
      arm: true,
      heloc: false
    },
    {
      value: 63,
      key: "3 Year ARM 300",
      term: 25,
      fixedTerm: 36,
      amortization: 25,
      arm: true,
      heloc: false
    },
    {
      value: 51,
      key: "3 Year ARM 180",
      term: 15,
      fixedTerm: 36,
      amortization: 15,
      arm: true,
      heloc: false
    },
    {
      value: 52,
      key: "3 Year ARM 240",
      term: 20,
      fixedTerm: 36,
      amortization: 20,
      arm: true,
      heloc: false
    },
    {
      value: 68,
      key: "5 Year ARM 480",
      term: 40,
      fixedTerm: 60,
      amortization: 40,
      arm: true,
      heloc: false
    },
    {
      value: 87,
      key: "5 Year ARM 348",
      term: 29,
      fixedTerm: 48,
      amortization: 29,
      arm: true,
      heloc: false
    },
    {
      value: 120,
      key: "5 Year 2mo ARM 240",
      term: 20,
      fixedTerm: 62,
      amortization: 20,
      arm: true,
      heloc: false
    },
    {
      value: 49,
      key: "5 Year ARM 180",
      term: 15,
      fixedTerm: 60,
      amortization: 15,
      arm: true,
      heloc: false
    },
    {
      value: 122,
      key: "5 Year 2mo ARM 180",
      term: 15,
      fixedTerm: 62,
      amortization: 15,
      arm: true,
      heloc: false
    },
    {
      value: 119,
      key: "5 Year 2mo ARM",
      term: 30,
      fixedTerm: 62,
      amortization: 30,
      arm: true,
      heloc: false
    },
    {
      value: 60,
      key: "5 Year ARM 300",
      term: 25,
      fixedTerm: 60,
      amortization: 25,
      arm: true,
      heloc: false
    },
    {
      value: 50,
      key: "5 Year ARM 240",
      term: 20,
      fixedTerm: 60,
      amortization: 20,
      arm: true,
      heloc: false
    },
    {
      value: 48,
      key: "7 Year ARM 180",
      term: 15,
      fixedTerm: 84,
      amortization: 15,
      arm: true,
      heloc: false
    },
    {
      value: 61,
      key: "7 Year ARM 300",
      term: 25,
      fixedTerm: 84,
      amortization: 25,
      arm: true,
      heloc: false
    },
    {
      value: 56,
      key: "7 Year ARM 240",
      term: 20,
      fixedTerm: 84,
      amortization: 20,
      arm: true,
      heloc: false
    },
    {
      value: 85,
      key: "7 Year ARM 348",
      term: 29,
      fixedTerm: 72,
      amortization: 29,
      arm: true,
      heloc: false
    },
    {
      value: 69,
      key: "7 Year ARM 480",
      term: 40,
      fixedTerm: 84,
      amortization: 40,
      arm: true,
      heloc: false
    },
    {
      value: 47,
      key: "10 Year ARM 180",
      term: 15,
      fixedTerm: 120,
      amortization: 15,
      arm: true,
      heloc: false
    },
    {
      value: 78,
      key: "10 Year ARM 120",
      term: 10,
      fixedTerm: 120,
      amortization: 10,
      arm: true,
      heloc: false
    },
    {
      value: 83,
      key: "10 Year ARM 348",
      term: 29,
      fixedTerm: 108,
      amortization: 29,
      arm: true,
      heloc: false
    },
    {
      value: 55,
      key: "10 Year ARM 480",
      term: 40,
      fixedTerm: 120,
      amortization: 40,
      arm: true,
      heloc: false
    },
    {
      value: 58,
      key: "10 Year ARM 240",
      term: 20,
      fixedTerm: 120,
      amortization: 20,
      arm: true,
      heloc: false
    },
    {
      value: 113,
      key: "3 Year ARM 288",
      term: 24,
      fixedTerm: 24,
      amortization: 24,
      arm: true,
      heloc: false
    },
    {
      value: 13,
      key: "30/15 Balloon",
      term: 15,
      fixedTerm: 180,
      amortization: 30,
      arm: false,
      heloc: false
    },
    {
      value: 74,
      key: "5/30 Balloon",
      term: 5,
      fixedTerm: 60,
      amortization: 30,
      arm: false,
      heloc: false
    },
    {
      value: 73,
      key: "7/30 Balloon",
      term: 84,
      fixedTerm: 84,
      amortization: 30,
      arm: false,
      heloc: false
    },
    {
      value: 118,
      key: "15/25 Balloon",
      term: 15,
      fixedTerm: 180,
      amortization: 25,
      arm: false,
      heloc: false
    },
    {
      value: 115,
      key: "7/20 Balloon",
      term: 84,
      fixedTerm: 84,
      amortization: 20,
      arm: false,
      heloc: false
    },
    {
      value: 116,
      key: "7/15 Balloon",
      term: 84,
      fixedTerm: 84,
      amortization: 15,
      arm: false,
      heloc: false
    },
    {
      value: 66,
      key: "HELOC 60",
      term: 5,
      fixedTerm: 60,
      amortization: 5,
      arm: false,
      heloc: true
    },
    {
      value: 21,
      key: "HELOC 120",
      term: 10,
      fixedTerm: 120,
      amortization: 10,
      arm: false,
      heloc: true
    },
    {
      value: 67,
      key: "HELOC 180",
      term: 15,
      fixedTerm: 180,
      amortization: 15,
      arm: false,
      heloc: true
    },
    {
      value: 64,
      key: "HELOC 240",
      term: 20,
      fixedTerm: 240,
      amortization: 20,
      arm: false,
      heloc: true
    },
    {
      value: 117,
      key: "HELOC 294",
      term: 25,
      fixedTerm: 294,
      amortization: 25,
      arm: false,
      heloc: true
    },
    {
      value: 77,
      key: "HELOC 300",
      term: 25,
      fixedTerm: 300,
      amortization: 25,
      arm: false,
      heloc: true
    },
    {
      value: 90,
      key: "HELOC 300 6 Month",
      term: 25,
      fixedTerm: 6,
      amortization: 25,
      arm: false,
      heloc: true
    },
    {
      value: 65,
      key: "HELOC 360",
      term: 30,
      fixedTerm: 360,
      amortization: 30,
      arm: false,
      heloc: true
    },
    {
      value: 99,
      key: "30 Year 6 Months",
      term: 1,
      fixedTerm: 363,
      amortization: 32,
      arm: false,
      heloc: false
    },
    {
      value: 101,
      key: "30 Year 12 Months",
      term: 1,
      fixedTerm: 360,
      amortization: 30,
      arm: false,
      heloc: false
    },
    {
      value: 100,
      key: "30 Year 9 Months",
      term: 1,
      fixedTerm: 360,
      amortization: 30,
      arm: false,
      heloc: false
    }
  ],
  loanUsage: [
    {
      key: "Purchase",
      value: 1,
      abbreviation: "Pur"
    },
    {
      key: "Rate/Term Refinance",
      value: 2,
      abbreviation: "RT"
    },
    {
      key: "C/O Refinance",
      value: 3,
      abbreviation: "CO"
    },
    {
      key: "Construction",
      value: 4,
      abbreviation: "Cn"
    },
    {
      key: "Construction-Perm",
      value: 5,
      abbreviation: "C2P"
    }
  ],
  nonQMDocLevel: [
    {
      nonQMDocLevelTypeId: 1,
      descriptionText: "24 Months W-2/Tax Returns",
      displayOrder: 1
    },
    {
      nonQMDocLevelTypeId: 2,
      descriptionText: "12 Months W-2/Tax Returns",
      displayOrder: 2
    },
    {
      nonQMDocLevelTypeId: 3,
      descriptionText: "24 Months Personal Bank Statements",
      displayOrder: 3
    },
    {
      nonQMDocLevelTypeId: 4,
      descriptionText: "12 Months Personal Bank Statements",
      displayOrder: 4
    },
    {
      nonQMDocLevelTypeId: 5,
      descriptionText: "24 Months Business Bank Statements",
      displayOrder: 5
    },
    {
      nonQMDocLevelTypeId: 6,
      descriptionText: "12 Months Business Bank Statements",
      displayOrder: 6
    },
    {
      nonQMDocLevelTypeId: 7,
      descriptionText: "Asset Depletion",
      displayOrder: 7
    },
    {
      nonQMDocLevelTypeId: 8,
      descriptionText: "24 Months 1099",
      displayOrder: 8
    },
    {
      nonQMDocLevelTypeId: 9,
      descriptionText: "12 Months 1099",
      displayOrder: 9
    },
    {
      nonQMDocLevelTypeId: 10,
      descriptionText: "24 Months P&L",
      displayOrder: 10
    },
    {
      nonQMDocLevelTypeId: 11,
      descriptionText: "12 Months P&L",
      displayOrder: 11
    },
    {
      nonQMDocLevelTypeId: 12,
      descriptionText: "WVOE",
      displayOrder: 12
    }
  ],
  nodTypes: [
    {
      nodTypeID: 1,
      description: "Foreclosure/Default",
      displayOrder: 1
    },
    {
      nodTypeID: 2,
      description: "Short Sale",
      displayOrder: 2
    },
    {
      nodTypeID: 3,
      description: "Deed in Lieu",
      displayOrder: 3
    }
  ],
  productOptions: [
    {
      key: "40-year Amortization",
      value: 5
    },
    {
      key: "50-year Amortization",
      value: 6
    },
    {
      key: "6 Month Promo",
      value: 12
    },
    {
      key: "abc1",
      value: 31
    },
    {
      key: "Another Option epps-55061",
      value: 64
    },
    {
      key: "Caution/Non-Saleable",
      value: 14
    },
    {
      key: "CPMMohanOptions",
      value: 27
    },
    {
      key: "DPA",
      value: 13
    },
    {
      key: "Duty To Serve",
      value: 102
    },
    {
      key: "EPMI",
      value: 8
    },
    {
      key: "EPPS-55061_2023-10-06 07:38:40",
      value: 99
    },
    {
      key: "IMAGIN",
      value: 9
    },
    {
      key: "Interest Only",
      value: 4
    },
    {
      key: "InvOption_Test",
      value: 10
    },
    {
      key: "Lender-paid MI",
      value: 1
    },
    {
      key: "Mohan Global Option 2",
      value: 24
    },
    {
      key: "No AVM",
      value: 15
    },
    {
      key: "No MI",
      value: 7
    },
    {
      key: "Testing on Release",
      value: 11
    },
    {
      key: "Waive Escrows",
      value: 2
    }
  ],
  prepayPenaltyTerms: [
    {
      key: "None",
      value: 0
    },
    {
      key: "1 yr",
      value: 1
    },
    {
      key: "2 yrs",
      value: 2
    },
    {
      key: "3 yrs",
      value: 3
    },
    {
      key: "4 yrs",
      value: 4
    },
    {
      key: "5 yrs",
      value: 5
    }
  ],
  specialProducts: [
    {
      key: "Asset Utilization",
      value: 752
    },
    {
      key: "FHA $100 Repo",
      value: 73
    },
    {
      key: "FHA 203H",
      value: 192
    },
    {
      key: "FHA 203K Rehab",
      value: 62
    },
    {
      key: "FHA 203K Streamline",
      value: 115
    },
    {
      key: "FHA Streamline",
      value: 27
    },
    {
      key: "FHLMC Refi Possible",
      value: 1427
    },
    {
      key: "FNMA Refi Now",
      value: 1426
    },
    {
      key: "Foreign National",
      value: 135
    },
    {
      key: "HomePossible",
      value: 20
    },
    {
      key: "HomeReady",
      value: 556
    },
    {
      key: "Homestyle",
      value: 109
    },
    {
      key: "HUD Section 184",
      value: 136
    },
    {
      key: "Professional",
      value: 892
    },
    {
      key: "Renovation",
      value: 1397
    },
    {
      key: "USDA Assist",
      value: 703
    },
    {
      key: "USDA Renovation",
      value: 1207
    },
    {
      key: "USDA Streamline",
      value: 704
    },
    {
      key: "VA IRRRL",
      value: 55
    },
    {
      key: "z",
      value: 1938
    }
  ],
  standardProducts: [
    {
      key: "Agency",
      value: 1
    },
    {
      key: "Non-agency",
      value: 5
    },
    {
      key: "FHA",
      value: 2
    },
    {
      key: "VA",
      value: 3
    },
    {
      key: "USDA",
      value: 4
    },
    {
      key: "Non-QM",
      value: 6
    }
  ],
  states: [
    {
      stateID: 2,
      state: "Alabama",
      abbreviation: "AL"
    },
    {
      stateID: 3,
      state: "Arkansas",
      abbreviation: "AR"
    },
    {
      stateID: 59,
      state: "American Samoa",
      abbreviation: "AS"
    },
    {
      stateID: 4,
      state: "Arizona",
      abbreviation: "AZ"
    },
    {
      stateID: 5,
      state: "California",
      abbreviation: "CA"
    },
    {
      stateID: 6,
      state: "Colorado",
      abbreviation: "CO"
    },
    {
      stateID: 7,
      state: "Connecticut",
      abbreviation: "CT"
    },
    {
      stateID: 8,
      state: "District of Columbia",
      abbreviation: "DC"
    },
    {
      stateID: 9,
      state: "Delaware",
      abbreviation: "DE"
    },
    {
      stateID: 10,
      state: "Florida",
      abbreviation: "FL"
    },
    {
      stateID: 62,
      state: "Federated States Of Micro",
      abbreviation: "FM"
    },
    {
      stateID: 11,
      state: "Georgia",
      abbreviation: "GA"
    },
    {
      stateID: 53,
      state: "Guam",
      abbreviation: "GU"
    },
    {
      stateID: 12,
      state: "Hawaii",
      abbreviation: "HI"
    },
    {
      stateID: 13,
      state: "Iowa",
      abbreviation: "IA"
    },
    {
      stateID: 14,
      state: "Idaho",
      abbreviation: "ID"
    },
    {
      stateID: 15,
      state: "Illinois",
      abbreviation: "IL"
    },
    {
      stateID: 16,
      state: "Indiana",
      abbreviation: "IN"
    },
    {
      stateID: 17,
      state: "Kansas",
      abbreviation: "KS"
    },
    {
      stateID: 18,
      state: "Kentucky",
      abbreviation: "KY"
    },
    {
      stateID: 19,
      state: "Lousiana",
      abbreviation: "LA"
    },
    {
      stateID: 20,
      state: "Massachusetts",
      abbreviation: "MA"
    },
    {
      stateID: 21,
      state: "Maryland",
      abbreviation: "MD"
    },
    {
      stateID: 22,
      state: "Maine",
      abbreviation: "ME"
    },
    {
      stateID: 61,
      state: "Marshall Islands",
      abbreviation: "MH"
    },
    {
      stateID: 23,
      state: "Michigan",
      abbreviation: "MI"
    },
    {
      stateID: 24,
      state: "Minnesota",
      abbreviation: "MN"
    },
    {
      stateID: 25,
      state: "Missouri",
      abbreviation: "MO"
    },
    {
      stateID: 58,
      state: "Northern Mariana Islands",
      abbreviation: "MP"
    },
    {
      stateID: 26,
      state: "Mississippi",
      abbreviation: "MS"
    },
    {
      stateID: 28,
      state: "North Carolina",
      abbreviation: "NC"
    },
    {
      stateID: 29,
      state: "North Dakota",
      abbreviation: "ND"
    },
    {
      stateID: 30,
      state: "Nebraska",
      abbreviation: "NE"
    },
    {
      stateID: 31,
      state: "New Hampshire",
      abbreviation: "NH"
    },
    {
      stateID: 32,
      state: "New Jersey",
      abbreviation: "NJ"
    },
    {
      stateID: 33,
      state: "New Mexico",
      abbreviation: "NM"
    },
    {
      stateID: 34,
      state: "Nevada",
      abbreviation: "NV"
    },
    {
      stateID: 35,
      state: "New York",
      abbreviation: "NY"
    },
    {
      stateID: 36,
      state: "Ohio",
      abbreviation: "OH"
    },
    {
      stateID: 37,
      state: "Oklahoma",
      abbreviation: "OK"
    },
    {
      stateID: 38,
      state: "Oregon",
      abbreviation: "OR"
    },
    {
      stateID: 39,
      state: "Pennsylvania",
      abbreviation: "PA"
    },
    {
      stateID: 40,
      state: "Puerto Rico",
      abbreviation: "PR"
    },
    {
      stateID: 60,
      state: "Palau",
      abbreviation: "PW"
    },
    {
      stateID: 41,
      state: "Rhode Island",
      abbreviation: "RI"
    },
    {
      stateID: 42,
      state: "South Carolina",
      abbreviation: "SC"
    },
    {
      stateID: 43,
      state: "South Dakota",
      abbreviation: "SD"
    },
    {
      stateID: 44,
      state: "Tennessee",
      abbreviation: "TN"
    },
    {
      stateID: 45,
      state: "Texas",
      abbreviation: "TX"
    },
    {
      stateID: 46,
      state: "Utah",
      abbreviation: "UT"
    },
    {
      stateID: 47,
      state: "Virginia",
      abbreviation: "VA"
    },
    {
      stateID: 57,
      state: "Virgin Islands",
      abbreviation: "VI"
    },
    {
      stateID: 48,
      state: "Vermont",
      abbreviation: "VT"
    },
    {
      stateID: 49,
      state: "Washington",
      abbreviation: "WA"
    },
    {
      stateID: 50,
      state: "Wisconsin",
      abbreviation: "WI"
    },
    {
      stateID: 51,
      state: "West Virginia",
      abbreviation: "WV"
    },
    {
      stateID: 52,
      state: "Wyoming",
      abbreviation: "WY"
    }
  ],
  unitTypes: [
    {
      unitTypeID: 2,
      description: "Apartment"
    },
    {
      unitTypeID: 3,
      description: "Basement"
    },
    {
      unitTypeID: 4,
      description: "Building"
    },
    {
      unitTypeID: 5,
      description: "Condo"
    },
    {
      unitTypeID: 6,
      description: "Department"
    },
    {
      unitTypeID: 7,
      description: "Floor"
    },
    {
      unitTypeID: 8,
      description: "Front"
    },
    {
      unitTypeID: 9,
      description: "Hangar"
    },
    {
      unitTypeID: 10,
      description: "Key"
    },
    {
      unitTypeID: 11,
      description: "Lobby"
    },
    {
      unitTypeID: 12,
      description: "Lot"
    },
    {
      unitTypeID: 13,
      description: "Lower"
    },
    {
      unitTypeID: 1,
      description: "none"
    },
    {
      unitTypeID: 14,
      description: "Office"
    },
    {
      unitTypeID: 15,
      description: "Penthouse"
    },
    {
      unitTypeID: 16,
      description: "Pier"
    },
    {
      unitTypeID: 17,
      description: "Rear"
    },
    {
      unitTypeID: 18,
      description: "Room"
    },
    {
      unitTypeID: 19,
      description: "Side"
    },
    {
      unitTypeID: 20,
      description: "Space"
    },
    {
      unitTypeID: 21,
      description: "Stop"
    },
    {
      unitTypeID: 22,
      description: "Suite"
    },
    {
      unitTypeID: 23,
      description: "Trailer"
    },
    {
      unitTypeID: 24,
      description: "Unit"
    },
    {
      unitTypeID: 25,
      description: "Upper"
    }
  ],
  officeUsers: [
    {
      userId: 38129,
      firstName: "Sarah",
      lastName: "Plambeck",
      office: "Backhouse Team",
      login: "splambeck"
    },
    {
      userId: 57698,
      firstName: "LO",
      lastName: "Test",
      office: "Backhouse Team",
      login: "Catestlo"
    },
    {
      userId: 63260,
      firstName: "Ray",
      lastName: "Turrietta",
      office: "Backhouse Team",
      login: "Rturrietta"
    },
    {
      userId: 65511,
      firstName: "Ann",
      lastName: "Rios",
      office: "Backhouse Team",
      login: "Arios"
    },
    {
      userId: 72638,
      firstName: "Testing",
      lastName: "Ligin",
      office: "Backhouse Team",
      login: "TestingLog"
    },
    {
      userId: 74898,
      firstName: "Dave",
      lastName: "Sommer",
      office: "Backhouse Team",
      login: "DSommer"
    },
    {
      userId: 78032,
      firstName: "Jolene",
      lastName: "Hill",
      office: "Backhouse Team",
      login: "JoleneH"
    },
    {
      userId: 87127,
      firstName: "Olga",
      lastName: "Moreno",
      office: "Backhouse Team",
      login: "OlgaMoreno"
    },
    {
      userId: 88242,
      firstName: "Coco",
      lastName: "Ronald",
      office: "Backhouse Team",
      login: "Roncoco"
    },
    {
      userId: 89562,
      firstName: "Lashana",
      lastName: "Hluchoweckyj",
      office: "Backhouse Team",
      login: "LashanaH"
    },
    {
      userId: 99309,
      firstName: "Tim",
      lastName: "McLane",
      office: "Backhouse Team",
      login: "TMclane"
    },
    {
      userId: 101586,
      firstName: "Pam",
      lastName: "McDonald",
      office: "Backhouse Team",
      login: "pmcdonah"
    },
    {
      userId: 119180,
      firstName: "ramakanth",
      lastName: "010",
      office: "Backhouse Team",
      login: "revani"
    },
    {
      userId: 45787,
      firstName: "Steve",
      lastName: "Sarmento",
      office: "CP-Test-Leads",
      login: "steveleads"
    },
    {
      userId: 45788,
      firstName: "Steve ",
      lastName: "Sarmento",
      office: "CP-Test-Self",
      login: "steveself"
    },
    {
      userId: 69584,
      firstName: "epps",
      lastName: "custom",
      office: "EPPS Custom TEST",
      login: "eppscustom"
    },
    {
      userId: 119177,
      firstName: "EPPS",
      lastName: "ForgotPWD",
      office: "EPPS Custom TEST",
      login: "user234"
    },
    {
      userId: 1,
      firstName: "George",
      lastName: "Chrisbacher",
      office: "HQ",
      login: "gxbacher"
    },
    {
      userId: 2,
      firstName: "Chris",
      lastName: "Remetz",
      office: "HQ",
      login: "cremex"
    },
    {
      userId: 11492,
      firstName: "Ines",
      lastName: "Virga",
      office: "HQ",
      login: "ivirga"
    },
    {
      userId: 15818,
      firstName: "EPPS",
      lastName: "Admin",
      office: "HQ",
      login: "eppsadmin"
    },
    {
      userId: 16055,
      firstName: "Namdev",
      lastName: "Saste",
      office: "HQ",
      login: "dolsema"
    },
    {
      userId: 18541,
      firstName: "Julie",
      lastName: "Meehan",
      office: "HQ",
      login: "jmeehama"
    },
    {
      userId: 21516,
      firstName: "Aarti",
      lastName: "Chopra",
      office: "HQ",
      login: "avang"
    },
    {
      userId: 25645,
      firstName: "Chris",
      lastName: "Steinhauer",
      office: "HQ",
      login: "csteinh"
    },
    {
      userId: 41574,
      firstName: "Kamran",
      lastName: "Ghanbari",
      office: "HQ",
      login: "kghan"
    },
    {
      userId: 41577,
      firstName: "Rajesh",
      lastName: "Sharma",
      office: "HQ",
      login: "rshark"
    },
    {
      userId: 42738,
      firstName: "Ben",
      lastName: "Bader",
      office: "HQ",
      login: "bbadep"
    },
    {
      userId: 43932,
      firstName: "Ruth",
      lastName: "Ithau",
      office: "HQ",
      login: "rithau"
    },
    {
      userId: 52949,
      firstName: "Erick",
      lastName: "Galvan",
      office: "HQ",
      login: "EGalvan"
    },
    {
      userId: 54698,
      firstName: "John",
      lastName: "Jukoski",
      office: "HQ",
      login: "jjukoz"
    },
    {
      userId: 79625,
      firstName: "Dion",
      lastName: "Macioci",
      office: "HQ",
      login: "DMaciocix"
    },
    {
      userId: 79626,
      firstName: "Lynette",
      lastName: "Beni",
      office: "HQ",
      login: "LBene"
    },
    {
      userId: 105056,
      firstName: "Ray",
      lastName: "Turrietta",
      office: "HQ",
      login: "rturetah"
    },
    {
      userId: 105057,
      firstName: "Lashana",
      lastName: "Hluchoweckyj",
      office: "HQ",
      login: "lhluch"
    },
    {
      userId: 105058,
      firstName: "Mousam",
      lastName: "Singh",
      office: "HQ",
      login: "msing"
    },
    {
      userId: 109366,
      firstName: "Rebecca",
      lastName: "Roberts",
      office: "HQ",
      login: "rebroberts"
    },
    {
      userId: 118369,
      firstName: "Griff",
      lastName: "Lagerstrom",
      office: "HQ",
      login: "grifflager"
    },
    {
      userId: 119176,
      firstName: "QA",
      lastName: "Admin",
      office: "HQ",
      login: "0qaadmin"
    },
    {
      userId: 119216,
      firstName: "Vivek",
      lastName: "A",
      office: "HQ",
      login: "SecUserMPS"
    },
    {
      userId: 119221,
      firstName: "Lo Comp Vivek",
      lastName: "Testing",
      office: "HQ",
      login: "locompuser1"
    },
    {
      userId: 119224,
      firstName: "Mohan",
      lastName: "LoanOfficer",
      office: "HQ",
      login: "mohanlo"
    },
    {
      userId: 119226,
      firstName: "Zee",
      lastName: "Test LO",
      office: "HQ",
      login: "zee-lo"
    },
    {
      userId: 119229,
      firstName: "Nilesh",
      lastName: "Gaydhani",
      office: "HQ",
      login: "nileshsg"
    },
    {
      userId: 119236,
      firstName: "Yuvaraj",
      lastName: "Sakaray",
      office: "HQ",
      login: "ysakaray"
    },
    {
      userId: 28948,
      firstName: "Ron",
      lastName: "Knight",
      office: "Implementation",
      login: "rknight"
    },
    {
      userId: 34195,
      firstName: "TPO",
      lastName: "PRMG",
      office: "Implementation",
      login: "lotest-tpoprmg"
    },
    {
      userId: 38113,
      firstName: "TPO",
      lastName: "Ron Test",
      office: "Implementation",
      login: "tporon"
    },
    {
      userId: 50147,
      firstName: "Norman",
      lastName: "DeLeon",
      office: "Implementation",
      login: "normand"
    },
    {
      userId: 65240,
      firstName: "Belinda",
      lastName: "Williams",
      office: "Implementation",
      login: "Belindaw"
    },
    {
      userId: 65284,
      firstName: "BelindaLO",
      lastName: "Williams",
      office: "Implementation",
      login: "Belindawlo"
    },
    {
      userId: 66674,
      firstName: "New",
      lastName: "User Test",
      office: "Implementation",
      login: "newuser"
    },
    {
      userId: 69316,
      firstName: "Amerihome Test",
      lastName: "Tom",
      office: "Implementation",
      login: "ahtom"
    },
    {
      userId: 80694,
      firstName: "Jimmy",
      lastName: "Benton",
      office: "Implementation",
      login: "JBenton"
    },
    {
      userId: 82895,
      firstName: "Dave",
      lastName: "Fowler",
      office: "Implementation",
      login: "davefowler"
    },
    {
      userId: 89056,
      firstName: "Shavyl",
      lastName: "Admin User",
      office: "Implementation",
      login: "ICSHassim1"
    },
    {
      userId: 90515,
      firstName: "Ron",
      lastName: "K",
      office: "Implementation",
      login: "tporonk"
    },
    {
      userId: 103327,
      firstName: "Sabina",
      lastName: "Rafailov",
      office: "Implementation",
      login: "srafailov"
    },
    {
      userId: 103566,
      firstName: "Sabina ",
      lastName: "Loan Officer",
      office: "Implementation",
      login: "SabinaTest"
    },
    {
      userId: 104758,
      firstName: "PSO",
      lastName: "User",
      office: "Implementation",
      login: "psouser"
    },
    {
      userId: 107685,
      firstName: "Brian",
      lastName: "Scheer",
      office: "Implementation",
      login: "brian.scheer@ice.com"
    },
    {
      userId: 109500,
      firstName: "Charity",
      lastName: "Wheatley",
      office: "Implementation",
      login: "charity.wheatley@ice.com"
    },
    {
      userId: 110732,
      firstName: "Samir",
      lastName: "Popalzai",
      office: "Implementation",
      login: "Samir"
    },
    {
      userId: 115891,
      firstName: "Amy",
      lastName: "Brown",
      office: "Implementation",
      login: "Amy.Brown@ice.com"
    },
    {
      userId: 116638,
      firstName: "John",
      lastName: "Spirko",
      office: "Implementation",
      login: "jspirko"
    },
    {
      userId: 116659,
      firstName: "Brian",
      lastName: "Pifer",
      office: "Implementation",
      login: "bpifer"
    },
    {
      userId: 116660,
      firstName: "Neeraj",
      lastName: "Jain",
      office: "Implementation",
      login: "njain"
    },
    {
      userId: 117869,
      firstName: "Chris",
      lastName: "Huynh",
      office: "Implementation",
      login: "ChristopherHuynh@1"
    },
    {
      userId: 71487,
      firstName: "Testing",
      lastName: "Test",
      office: "name change",
      login: "CSGTest"
    },
    {
      userId: 119230,
      firstName: "Srinu",
      lastName: "Nanavath",
      office: "NNN ",
      login: "NSrinu"
    },
    {
      userId: 60282,
      firstName: "John",
      lastName: "Jukoski",
      office: "PM and Dev",
      login: "jjukoski"
    },
    {
      userId: 63663,
      firstName: "Veronika",
      lastName: "Beyer",
      office: "PM and Dev",
      login: "vbeyer"
    },
    {
      userId: 78962,
      firstName: "Test",
      lastName: "Devops",
      office: "PM and Dev",
      login: "TDevops"
    },
    {
      userId: 100018,
      firstName: "Namdev",
      lastName: "Saste",
      office: "PM and Dev",
      login: "nsaste"
    },
    {
      userId: 119232,
      firstName: "TesterQA",
      lastName: "LO",
      office: "QA LO TEST",
      login: "testqalo"
    },
    {
      userId: 119233,
      firstName: "testqa",
      lastName: "Client Admin",
      office: "QA LO TEST",
      login: "testqa_CA"
    },
    {
      userId: 119234,
      firstName: "testqa",
      lastName: "Super Admin",
      office: "QA LO TEST",
      login: "testqa_admin"
    },
    {
      userId: 84149,
      firstName: "RK",
      lastName: "TPO Correspendent",
      office: "RK - TPO Correspondent",
      login: "RKTPOCorrespondent"
    },
    {
      userId: 84150,
      firstName: "RK",
      lastName: "TPO Wholesale",
      office: "RK - TPO Wholesale",
      login: "RKTPOWholesale"
    },
    {
      userId: 78849,
      firstName: "Secondary",
      lastName: "Secondary",
      office: "Secondary",
      login: "SecondaryMPS"
    },
    {
      userId: 20960,
      firstName: "Tracy",
      lastName: "Bonner",
      office: "Support",
      login: "tbonneradmin"
    },
    {
      userId: 24373,
      firstName: "Doug",
      lastName: "Foster",
      office: "Support",
      login: "dfadmin"
    },
    {
      userId: 24634,
      firstName: "Doug",
      lastName: "Foster LO",
      office: "Support",
      login: "dflo1"
    },
    {
      userId: 42208,
      firstName: "Brad",
      lastName: "Yahrling",
      office: "Support",
      login: "byahrling"
    },
    {
      userId: 56617,
      firstName: "Tom",
      lastName: "Lyons",
      office: "Support",
      login: "tlyonzz"
    },
    {
      userId: 75368,
      firstName: "Kirsten",
      lastName: "King",
      office: "Support",
      login: "kking"
    },
    {
      userId: 75371,
      firstName: "Bret",
      lastName: "Roberts",
      office: "Support",
      login: "broberts1"
    },
    {
      userId: 75372,
      firstName: "Lisa",
      lastName: "Evans",
      office: "Support",
      login: "levans1"
    },
    {
      userId: 79428,
      firstName: "Tomas",
      lastName: "Esquivel",
      office: "Support",
      login: "TEsquivel"
    },
    {
      userId: 84660,
      firstName: "Robby",
      lastName: "Hill",
      office: "Support",
      login: "RobHill1"
    },
    {
      userId: 85378,
      firstName: "Chris",
      lastName: "Fernandez",
      office: "Support",
      login: "cfernandez"
    },
    {
      userId: 89268,
      firstName: "Rosie",
      lastName: "Huckaby",
      office: "Support",
      login: "Rosie"
    },
    {
      userId: 91025,
      firstName: "Sarah",
      lastName: "Plambeck",
      office: "Support",
      login: "Splambeck1"
    },
    {
      userId: 96141,
      firstName: "Taylor",
      lastName: "Atwell",
      office: "Taylor ECC USDA test",
      login: "Tatw2"
    },
    {
      userId: 905,
      firstName: "Rates",
      lastName: "Admin",
      office: "Tech",
      login: "ra27ra89001"
    },
    {
      userId: 14421,
      firstName: "George",
      lastName: "Test",
      office: "Tech",
      login: "george"
    },
    {
      userId: 23583,
      firstName: "Ben",
      lastName: "Harms",
      office: "Tech",
      login: "bharms"
    },
    {
      userId: 36138,
      firstName: "Vanda",
      lastName: "Maxey",
      office: "Tech",
      login: "vmaxey2"
    },
    {
      userId: 49266,
      firstName: "Lock",
      lastName: "Desk",
      office: "Tech",
      login: "lockdeskEPPS"
    },
    {
      userId: 62941,
      firstName: "test",
      lastName: "lo",
      office: "WHOLESALE-BP",
      login: "TEST_BP"
    }
  ],
  termRange: [
    {
      minTerm: 0,
      maxTerm: 0
    },
    {
      minTerm: 12,
      maxTerm: 12
    },
    {
      minTerm: 110,
      maxTerm: 110
    },
    {
      minTerm: 96,
      maxTerm: 96
    },
    {
      minTerm: 348,
      maxTerm: 348
    },
    {
      minTerm: 1,
      maxTerm: 10
    },
    {
      minTerm: 202,
      maxTerm: 204
    },
    {
      minTerm: 280,
      maxTerm: 358
    },
    {
      minTerm: 360,
      maxTerm: 360
    },
    {
      minTerm: 80,
      maxTerm: 300
    },
    {
      minTerm: 180,
      maxTerm: 180
    },
    {
      minTerm: 201,
      maxTerm: 360
    },
    {
      minTerm: 24,
      maxTerm: 24
    },
    {
      minTerm: 288,
      maxTerm: 288
    },
    {
      minTerm: 50,
      maxTerm: 110
    },
    {
      minTerm: 85,
      maxTerm: 115
    },
    {
      minTerm: 720,
      maxTerm: 720
    },
    {
      minTerm: 357,
      maxTerm: 360
    },
    {
      minTerm: 120,
      maxTerm: 120
    },
    {
      minTerm: 300,
      maxTerm: 360
    },
    {
      minTerm: 300,
      maxTerm: 300
    },
    {
      minTerm: 36,
      maxTerm: 36
    },
    {
      minTerm: 241,
      maxTerm: 360
    },
    {
      minTerm: 1008,
      maxTerm: 1008
    },
    {
      minTerm: 48,
      maxTerm: 48
    },
    {
      minTerm: 312,
      maxTerm: 312
    },
    {
      minTerm: 187,
      maxTerm: 204
    },
    {
      minTerm: 60,
      maxTerm: 60
    },
    {
      minTerm: 240,
      maxTerm: 360
    },
    {
      minTerm: 132,
      maxTerm: 132
    },
    {
      minTerm: 100,
      maxTerm: 360
    },
    {
      minTerm: 144,
      maxTerm: 144
    },
    {
      minTerm: 238,
      maxTerm: 240
    },
    {
      minTerm: 340,
      maxTerm: 360
    },
    {
      minTerm: 480,
      maxTerm: 480
    },
    {
      minTerm: 85,
      maxTerm: 105
    },
    {
      minTerm: 2,
      maxTerm: 360
    },
    {
      minTerm: 222,
      maxTerm: 333
    },
    {
      minTerm: 168,
      maxTerm: 168
    },
    {
      minTerm: 240,
      maxTerm: 240
    },
    {
      minTerm: 84,
      maxTerm: 84
    },
    {
      minTerm: 240,
      maxTerm: 358
    },
    {
      minTerm: 72,
      maxTerm: 72
    },
    {
      minTerm: 111,
      maxTerm: 222
    },
    {
      minTerm: 1,
      maxTerm: 1
    },
    {
      minTerm: 358,
      maxTerm: 360
    }
  ],
  underwritingMethods: [
    {
      underwritingMethodID: 1,
      underwritingMethod: "DU"
    },
    {
      underwritingMethodID: 2,
      underwritingMethod: "LPA"
    },
    {
      underwritingMethodID: 3,
      underwritingMethod: "LQA"
    },
    {
      underwritingMethodID: 4,
      underwritingMethod: "Manual Underwriting"
    },
    {
      underwritingMethodID: 5,
      underwritingMethod: "Other"
    }
  ]
};
export {
  sampleClientLookups
};
